import 'es6-promise/auto'
import Vue from 'vue';
import Axios from 'axios';
import Alram from './components/common/alram.vue';
import validation from 'validator';
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';

Vue.use(VueFileAgent);
import DropImg from "./components/common/dragImgFile.vue";
import ProfileList from "./components/common/dfile1.vue";

Vue.component("alarm", Alram);
Vue.component('dropimg', DropImg);
Vue.component("dfile", ProfileList);
new Vue({
    el: '#footer',
    data: function() {
        return {
            isRecommnend:false,
            mainName: "",
          fileImgProfile:[],
            viewModel:{
                corporation     : '',
                responsibility  : '',
                department      : '',
                phoneNumber     : '',
                cellPhoneNumber : '',
                email           : '',
                content         : '',
            },
            phoneNumberCheck   : '',
            cellPhoneNumberCheck   : ''
        }
    },
    mounted: function() {

    },
    created: function(){
    },
    watch:{
        phoneNumberCheck(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
			if(reg.exec(value) !== null ) {
				this.phoneNumberCheck = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.phoneNumberCheck = '';
			}
			this.viewModel.phoneNumber = this.phoneNumberCheck;
		},
        cellPhoneNumberCheck(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
			if(reg.exec(value) !== null ) {
				this.cellPhoneNumberCheck = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.cellPhoneNumberCheck = '';
			}
			this.viewModel.cellPhoneNumber = this.cellPhoneNumberCheck;
		}
    },
    methods: {
        fnOnClickRecomendMessage:function(){
            this.fnOnLoadMessage();
        },
        fnOnLoadMessage:function(evt){
            return this.isRecommnend = true;
        },
        onClickIntro: function(){
            location.href="/customer/footer/intro?shared=Y";
        },
        onClickPromotion: function(){
            location.href="/customer/footer/promotion?shared=Y";
        },
        onClickPartnership: function(){
            location.href="/customer/footer/partnership?shared=Y";
        },
        onClickPath: function(){
            location.href="/customer/footer/path?shared=Y";
        },
        onClickTerms: function(){
            location.href="/customer/footer/terms?shared=Y";
        },
        onClickPrivacy: function(){
            location.href="/customer/footer/privacy?shared=Y";
        },
        onClickEmailPolicy: function(){
            location.href="/customer/footer/email?shared=Y";
        },
        onClickInquirePartership: function(){
            location.href="/customer/footer/inquirepartnership?shared=Y";
        },
        //연락처체크
		fnOnChkPhonNum: function(e){
			let vm = this;
			vm.phoneNumberCheck = e.target.value;
		},
        //휴대폰체크
		fnOnChkCellPhonNum: function(e){
			let vm = this;
			vm.cellPhoneNumberCheck = e.target.value;
		},
        fnSetInquirePartership: function(){
            let vm = this;

			//유효성 체크
			let _IsCor	    = validation.isEmpty(vm.viewModel.corporation);
            let _IsRes	    = validation.isEmpty(vm.viewModel.responsibility);
            let _IsDepartment	= validation.isEmpty(vm.viewModel.department);
            let _IsPhonNum	= validation.isEmpty(vm.viewModel.phoneNumber);
            let _IsEmail	= validation.isEmpty(vm.viewModel.email);
            let _IsContent	= validation.isEmpty(vm.viewModel.content);

          if(_IsCor){
            swal('회사명을 입력해주세요.!!!!!').then(function(){
              $('#corporation').focus();
            });
            return false;
          }else if(_IsRes){
            swal('담당자명을 입력해주세요.!!!!').then(function(){
              $('#responsibility').focus();
            });
            return false;
          }else if(_IsDepartment){
            swal('소속을 입력해주세요.!!!!').then(function(){
              $('#department').focus();
            });
            return false;
          } else if(_IsPhonNum){
            swal('연락처를 입력해주세요.!!!!').then(function(){
              $('#phoneNum').focus();
            });
            return false;
          }else if(_IsEmail){
            swal('이메일을 입력해주세요.').then(function(){
              $('#email').focus();
            });
            return false;
          }else if(_IsContent){
            swal('내용을 입력해주세요.').then(function(){
              $('#content').focus();
            });
            return false;
          }

/*if( _IsCor || _IsRes || _IsDepartment || _IsPhonNum ||
    _IsEmail || _IsContent){
let _word = '';
    if(_IsCor){
        _word = '회사명';
    } else if(_IsRes){
        _word = '담당자명';
    } else if(_IsDepartment){
        _word = '소속';
    } else if(_IsPhonNum){
        _word = '연락처';
    } else if(_IsEmail){
        _word = '이메일';
    } else if(_IsContent){
        _word = '내용';
    }

    if( _IsCor || _IsRes || _IsDepartment
     || _IsEmail || _IsContent) {
        swal({
            text        : _word+'을 입력해주세요.',
        });
} else if(_IsPhonNum){
        swal({
            text        : _word+'를 입력해주세요.',
        });
    }
}
 */
else {

    let _param = { corporation      : vm.viewModel.corporation
                 , responsibility   : vm.viewModel.responsibility
                 , department       : vm.viewModel.department
                 , phoneNumber      : vm.viewModel.phoneNumber
                 , cellPhoneNumber  : vm.viewModel.cellPhoneNumber
                 , email            : vm.viewModel.email
                 , content          : vm.viewModel.content
                 , fileKey		    : $('#fileKey').val()
                 };
    let param = { partnerShipParam : _param};
    Axios.post("/api/footer/partership/inquire", param).then(function(response) {
        let result = response.data.resultCnt;
        if (result > 0) {
            swal({
                title      : '',
                text       : '정상적으로 등록되었습니다.',
                // icon       : vm.fnOnLoadSwalImageData('success'),
                buttons: {
                    cancel: {
                        text: "취소",
                        value: false,
                        visible: false,
                    },
                    confirm: {
                        text: "확인",
                        value: true,
                        visible: true,
                    },
                },
                dangerMode : true
            }).then(result => {
                if(result){
                    location.href="/customer/footer/partnership";
                }
            });
        } else if(result == -999) {
            swal({
                title      : '등록 실패',
                text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon       : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                    cancel: {
                        text: "취소",
                        value: false,
                        visible: false,
                    },
                    confirm: {
                        text: "확인",
                        value: true,
                        visible: true,
                    },
                },
                dangerMode : true
            }).then(result => {
                if(result){
                    return false;
                }
            });
        } else {
            swal({
                title      : '',
                text       : '등록에 실패하였습니다',
                // icon       : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                    cancel: {
                        text: "취소",
                        value: false,
                        visible: false,
                    },
                    confirm: {
                        text: "확인",
                        value: true,
                        visible: true,
                    },
                },
                dangerMode : true
            });
            return false;
        }
    }) .catch(function(ex) {
        console.log(ex);
        swal({
            title      : '',
            text       : '등록에 실패하였습니다',
            // icon       : vm.fnOnLoadSwalImageData('error'),
            buttons: {
                cancel: {
                    text: "취소",
                    value: false,
                    visible: false,
                },
                confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                },
            },
            dangerMode : true
        });
        return false;
    });
}
},
//alert 이미지 호출
fnOnLoadSwalImageData:function(value){
let _icon = "/design/common/images/sub/img_alert_"+value+".png";
return _icon;
},
}
});
